import React, { PropTypes } from 'react';

export default class DiffusionHeader extends React.Component {
  static propTypes = {
    selectedUsers: PropTypes.array.isRequired,
    openModal: PropTypes.func.isRequired,
    clearSelection: PropTypes.func.isRequired,
  };

  render() {
    const { selectedUsers, openModal, clearSelection } = this.props;
    return (
      <div className="ui segment">
        <div className="header">
          Destinataires
          <em> {selectedUsers.length} sélectionné(s)</em>
          <span className="action">
            <button
              className="ui compact labeled icon button"
              onClick={clearSelection}
            >
              <i className="recycle icon" />
              Vider
            </button>
            <button
              className="ui compact labeled icon button"
              onClick={openModal}
            >
              <i className="add user icon" />
              Ajouter
            </button>
          </span>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/messaging/components/DiffusionHeader.js